module.exports = __webpack_public_path__ + "static/media/logo.42d55c7f.png";